const ArrowSolidIcon = ({ style = {}, color = '#141B34', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={style} width={width} height={height} color={color} fill="none">
			<defs />
			<path
				fill={color}
				d="M15.805,5.407 C15.478,4.962 14.852,4.867 14.407,5.195 C14.062,5.449 13.733,5.704 13.447,5.927 C12.876,6.372 12.112,6.986 11.344,7.652 C10.582,8.314 9.794,9.048 9.188,9.733 C8.886,10.075 8.609,10.428 8.401,10.772 C8.21,11.089 8,11.524 8,12 C8,12.476 8.21,12.912 8.401,13.228 C8.609,13.572 8.886,13.925 9.188,14.267 C9.794,14.952 10.582,15.686 11.344,16.348 C12.112,17.015 12.876,17.628 13.447,18.073 C13.733,18.297 14.062,18.551 14.407,18.805 C14.852,19.133 15.478,19.038 15.805,18.593 C15.937,18.414 16,18.206 16,18 L16,12 L16,6 C16,5.794 15.937,5.586 15.805,5.407 Z"
			/>
		</svg>
	);
};

export default ArrowSolidIcon;
